import Numeral from 'numeral'
import { useMemo } from 'react'

import WAN from '@/assets/WAN@2x.png'
import { useQueryTokenPrice } from '@/utils/queries'

export default function WanPrice() {
  const { data: tokensPrice, isLoading: tokensPriceLoading } =
    useQueryTokenPrice()

  const WanPrice = useMemo(() => {
    if (!tokensPriceLoading && tokensPrice) {
      return tokensPrice.wanchain?.usd || '0'
    } else {
      return '0'
    }
  }, [tokensPrice, tokensPriceLoading])

  return (
    <div>
      <div className="bg-dark-111 h-[3.8rem] w-full rounded-2xl p-[10px] flex items-center justify-center text-white cursor-pointer">
        <img className="relative w-[26px] h-[26px]" src={WAN} alt="wanIcon" />
        <span className="inline-block ml-[10px] font-medium">
          {Numeral(WanPrice).format('$0,0.0000')}
        </span>
      </div>
    </div>
  )
}
